var VERSION = 1781767028929
export  {
	VERSION
} 
